import { render, staticRenderFns } from "./Yzcl.vue?vue&type=template&id=499b4493&scoped=true&"
import script from "./Yzcl.vue?vue&type=script&lang=js&"
export * from "./Yzcl.vue?vue&type=script&lang=js&"
import style0 from "./Yzcl.vue?vue&type=style&index=0&id=499b4493&lang=less&scoped=true&"
import style1 from "./Yzcl.vue?vue&type=style&index=1&id=499b4493&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b4493",
  null
  
)

export default component.exports